const themeName = process.env.VUE_APP_THEME_NAME

export default [
  {
    path: '/:lang/dashboard',
    name: 'dashboard',
    component: () => import(`@/views/${themeName}/dashboard/DashboardCompany.vue`),
    meta: {
      pageTitle: 'Dashboard',
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    },
  },
]
